import React, { useEffect, useState } from 'react';
import EnablingFeature from '../../../components/EnablingFeature';
import InvestmentSplashScreen from './Splash/InvestmentSplashScreen';
import { useGetQuery } from '../../../customhooks/useGetQuery';
import { Spin } from 'antd';
import { SettingOutlined } from '@ant-design/icons';

const Investments = () => {
    const [showSplash, setShowSplash] = useState(false);

    const { entries, isFetching } = useGetQuery<{
        connected: boolean;
        status: string;
    }>({
        url: '/investments/account/verify',
        params: { productCode: 'ARMMMF' },
        cacheKey: 'investment-link-ARMMMF'
    });

    useEffect(() => {
        if (!entries?.connected && entries.status === 'UNLINKED') {
            setShowSplash(true);
        }
    }, [entries]);

    return (
        <EnablingFeature flag='Investments'>
            <Spin
                fullscreen
                spinning={isFetching}
                delay={500}
                indicator={
                    <SettingOutlined
                        style={{ fontSize: 100, color: '#329FC1' }}
                        spin
                    />
                }
            />

            <div className=''>
                <h1 className='px-4 pt-[32px] lg:px-0 lg:pt-0 text-[20px] font-medium leading-[30px] text-ebony'>
                    Investments
                </h1>

                {showSplash && (
                    <InvestmentSplashScreen setShowSplash={setShowSplash} />
                )}
            </div>
        </EnablingFeature>
    );
};

export default Investments;
